// cart-timer.js
function startOrUpdateCartTimer() {
    let timerInterval = window.cartTimerInterval || null;
    const timerKey = 'cartTimer';
    const initialMins = 10;
    
    if (timerInterval) {
        clearInterval(timerInterval);
    }

    let secs = initialMins * 60;
    const storedTime = sessionStorage.getItem(timerKey);

    if (storedTime && parseInt(storedTime) > 0) {
        secs = parseInt(storedTime);
    } else {
        sessionStorage.setItem(timerKey, secs);
    }
    
    timerInterval = setInterval(() => {
        let currentMinutes = Math.floor(secs / 60);
        let currentSeconds = secs % 60;
        
        if (currentSeconds <= 9) {
            currentSeconds = "0" + currentSeconds;
        }

        const timerElement = document.getElementById("timer");
        if (timerElement) {
            timerElement.innerHTML = `${currentMinutes}:${currentSeconds}`;
        }
        
        if (secs <= 0) {
            clearInterval(timerInterval);
            sessionStorage.removeItem(timerKey);
        } else {
            secs--;
            sessionStorage.setItem(timerKey, secs);
        }
    }, 1000);

    window.cartTimerInterval = timerInterval;
}